import { connect } from "react-redux";
import Route from "./Route";

const mapStateToProps = ({ login, common }) => {
  const { isAuthenticated, user } = login;
  const { pendingAuthActions, hrAdmin, employee, requirePasswordReset, token } = user;
  const { menuItems } = common;

  return {
    isAuthenticated,
    pendingAuthActions,
    menuItems,
    hrAdmin,
    employee,
    requirePasswordReset,
    token,
  };
};

const RouteContainer = connect(mapStateToProps)(Route);

export default RouteContainer;



// WEBPACK FOOTER //
// ./components/RouteContainer.js